import React from 'react';
import { ArrowRight, Users, Building2 } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { getRoute } from '../utils/routes';
import useScrollAnimation from '@/hooks/useScrollAnimation';

const CallToAction = () => {
  const navigate = useNavigate();
  const { ref, isVisible } = useScrollAnimation();

  const t = {
    sectionTitle: 'Get In Touch',
    influencerBox: 'For Influencers',
    influencerCta: 'Sign Up',
    brandBox: 'For Brands',
    brandCta: 'Work With Us',
  };

  const handleWorkWithUs = () => {
    navigate(getRoute('about'));
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        const offsetTop = element.offsetTop - 150;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  return (
    <section 
      ref={ref}
      className={`py-12 bg-black bg-opacity-75 scroll-animate ${isVisible ? 'visible' : ''}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-[#FFDD59] text-center mb-6">
          {t.sectionTitle}
        </h2>

        {/* Two Action Boxes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto">
          {/* Brand Box */}
          <div className="bg-gray-900 border border-gray-700 text-white rounded-2xl p-6 md:p-8 transition-all duration-300 card-hover-glow hover:border-[#FFDD59] text-center">
            <Building2 className="mx-auto mb-4" size={48} color="#FFDD59" />
            <h3 className="text-xl md:text-2xl font-bold text-[#FFDD59] mb-2">{t.brandBox}</h3>
            <button 
              onClick={handleWorkWithUs}
              className="w-full mt-4 py-3 bg-[#FFDD59] text-black font-bold rounded-lg hover:bg-yellow-400 transition flex items-center justify-center gap-2"
            >
              {t.brandCta}
              <ArrowRight size={20} />
            </button>
          </div>
          
          {/* Influencer Box */}
          <div className="bg-gray-900 border border-gray-700 text-white rounded-2xl p-6 md:p-8 transition-all duration-300 card-hover-glow hover:border-[#FFDD59] text-center">
            <Users className="mx-auto mb-4" size={48} color="#FFDD59" />
            <h3 className="text-xl md:text-2xl font-bold text-[#FFDD59] mb-2">{t.influencerBox}</h3>
            <Link 
              to={getRoute('influencer')}
              className="w-full mt-4 py-3 bg-[#FFDD59] text-black font-bold rounded-lg hover:bg-yellow-400 transition flex items-center justify-center gap-2"
            >
              {t.influencerCta}
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
